import { render, staticRenderFns } from "./RequestsHistory.vue?vue&type=template&id=53bb6f5b&scoped=true&"
import script from "./RequestsHistory.vue?vue&type=script&lang=js&"
export * from "./RequestsHistory.vue?vue&type=script&lang=js&"
import style0 from "./RequestsHistory.vue?vue&type=style&index=0&id=53bb6f5b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bb6f5b",
  null
  
)

export default component.exports